<template>
    <div>
        <b-input-group>
          <b-form-input id="input-2" type="text" v-model="contact.name" :required="true" :placeholder="$gettext('New Customer name')"></b-form-input>
        </b-input-group>

        <div class="form-required text-danger">
          <span>{{ $gettext('Customer name is required') }}</span>
        </div>
    </div>
</template>

<script>
import CustomerService from "@/store/services/customer.service";

export default {
    name: "ContactFormSimple",
    props: {
        contact: {
            type: Object,
            required: true
        }
    },
    methods: {
        saveForm() {
            CustomerService.create(this.contact).then((response) => {
                this.$emit('created', response.data);
                this.$store.commit('setAlert', {
                    title: this.$gettext("Contact added"),
                    text: this.$gettext("The contact was added to your contact list."),
                    variant: "success",
                    duration: 4
                });
            }).catch((error) => {
                let msg = this.$gettext('The contact could not be added to your contact list.');
                if (error.data.email) {
                    msg = this.$gettext('Invalid email address');
                } else if (error.data.hourly_rate) {
                    msg = this.$gettext('Invalid hourly rate');
                } else if (error.data.default_km_rate) {
                    msg = this.$gettext('Invalid default KM rate');
                } else if (error.data.default_payment_term) {
                    msg = this.$gettext('Invalid default payment term');
                } else if (error.data.name) {
                    msg = this.$gettext('Contact name already exists');
                } else {
                    let firstDictKey = Object.keys(error.data)[0];
                    if (firstDictKey) {
                        msg = error.data[firstDictKey];
                    }
                }
                this.$store.commit('setAlert', {
                    title: this.$gettext("Error adding contact"),
                    text: msg,
                    variant: "danger",
                    duration: 4
                });
            });
        }
    }
}
</script>